import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="price-preview"
export default class extends Controller {
  static targets = ["autoPrice", "manualPrice", "priceInput", "preview", "calculatedPrice", "priceDetails"]
  static values = { url: String }

  connect() {
    // Store bound references for proper cleanup
    this.boundHandleCardSelected = this.handleCardSelected.bind(this)
    this.boundHandleCardCleared = this.handleCardCleared.bind(this)

    // Listen for card selection events
    document.addEventListener("card-search:selected", this.boundHandleCardSelected)
    document.addEventListener("card-search:cleared", this.boundHandleCardCleared)

    // Initial state
    this.toggle()
  }

  disconnect() {
    document.removeEventListener("card-search:selected", this.boundHandleCardSelected)
    document.removeEventListener("card-search:cleared", this.boundHandleCardCleared)
  }

  toggle() {
    const isAutoPrice = this.autoPriceTarget.checked

    if (isAutoPrice) {
      this.manualPriceTarget.classList.add("hidden")
      this.updatePreview()
    } else {
      this.manualPriceTarget.classList.remove("hidden")
      this.previewTarget.classList.add("hidden")
    }
  }

  handleCardSelected(event) {
    if (this.autoPriceTarget.checked) {
      this.updatePreview()
    }
  }

  handleCardCleared() {
    this.previewTarget.classList.add("hidden")
  }

  async updatePreview() {
    // Find the card ID from the form
    const cardIdInput = document.querySelector('[data-card-search-target="cardId"]')
    const conditionSelect = document.querySelector('select[name*="condition"]')

    if (!cardIdInput || !cardIdInput.value) {
      this.previewTarget.classList.add("hidden")
      return
    }

    const cardId = cardIdInput.value
    const condition = conditionSelect ? conditionSelect.value : ""

    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("card_id", cardId)
      if (condition) {
        url.searchParams.set("condition", condition)
      }

      const response = await fetch(url, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Price preview failed")

      const data = await response.json()

      if (data.error) {
        this.previewTarget.classList.add("hidden")
        return
      }

      this.displayPreview(data)
    } catch (error) {
      console.error("Price preview error:", error)
      this.previewTarget.classList.add("hidden")
    }
  }

  displayPreview(data) {
    this.calculatedPriceTarget.textContent = `$${data.final_price.toFixed(2)}`

    const details = []
    if (data.market_price) {
      details.push(`Market: $${data.market_price.toFixed(2)}`)
    }
    if (data.condition_multiplier && data.condition_multiplier < 1) {
      details.push(`Condition: ${(data.condition_multiplier * 100).toFixed(0)}%`)
    }
    if (data.rule_applied && data.rule_applied !== "store_default") {
      details.push(`Rule: ${data.rule_applied}`)
    }

    this.priceDetailsTarget.textContent = details.join(" | ")
    this.previewTarget.classList.remove("hidden")
  }

  // Called when condition changes
  conditionChanged() {
    if (this.autoPriceTarget.checked) {
      this.updatePreview()
    }
  }
}
